module.exports = __webpack_public_path__ + "img/logo-scorpion-sm.c9ca53c1.png";